import {User} from '../user/user.model';
import {Young} from '../user/young.model';
import {RelationUser} from '../user/relation-user.model';
import {Program} from '../event/program.model';
import {Address} from '../event/place/address.model';
import {PlaceEventDTO} from '../dto/place-event.dto';
import {SchoolLevel} from '../user/school-level.model';

export class RegisterYoungDTO {
    userRegistered: User;
    youngRegistered: Young;
    addressYoung: Address;
    schoolLevelYoung: SchoolLevel;
    listOfYoungPDifficulteScolaireIds: number[];
    listOfYoungPDisciplineDifficulteScolaireIds: number[];
}

export class RegisterResponsableDTO {
    userResponsable: User;
    userFamily: RelationUser;
    isSecondResponsable: boolean;
    userSecondResponsable: User;
    userFamilySecondResponsable: RelationUser;
    userYoungToRegister: User;
}

export class RegisterEventDTO {
    userRegistered: User;
    program: Program;
    ListOfPlaceEvent: PlaceEventDTO[];
}

export class GlobalRegisterDTO {
    youngRegister: RegisterYoungDTO;
    responsableYoung: RegisterResponsableDTO;
    eventToRegister: RegisterEventDTO;
}
